import { useQuery } from '@tanstack/react-query';
import { getCart } from '~/apis/order';

export const useGetCartCount = () => {
  return useQuery({
    queryKey: ['cart-count'],
    queryFn: getCart,
    select: (response) => response.data.productCount,
    retry: 0,
  });
};
